module.exports = __webpack_public_path__ + "img/upload.a5ae9712.svg";